<rt-dialog-header [heading]="'app.requisitions.assign_hires_dialog.heading' | translate">
  {{ 'app.requisitions.assign_hires_multi_requisitions_dialog.subheading' | translate }}
</rt-dialog-header>

<rt-dialog-body layout-vertical>
  @if (notEnoughOpenings) {
    <rt-infobox
      [heading]="
        'app.requisitions.assign_hires_dialog.not_enough_openings_infobox.heading'
          | translate: { count: openingsNumber }
      "
      [isDismissible]="false"
      type="transparent"
      iconName="info-outline"
      margin-bottom-small
    >
      <span
        [innerHTML]="
          (requisitions.length > 1
            ? 'app.requisitions.assign_hires_dialog.not_enough_openings_infobox_message_plural'
            : 'app.requisitions.assign_hires_dialog.not_enough_openings_infobox.message'
          ) | translate: { count: openingsNumber }
        "
      ></span>
    </rt-infobox>
  }
  <div class="grid-row">
    <rt-heading variant="heading">{{
      'app.requisitions.assign_hires_dialog.candidate_label' | translate
    }}</rt-heading>
    <div></div>
    <rt-heading variant="heading" margin-right-small-x>{{
      'app.requisitions.assign_hires_dialog.requisition_label' | translate
    }}</rt-heading>
    <rt-heading variant="heading" margin-left-small-x>{{
      'app.requisitions.assign_hires_dialog.opening_label' | translate
    }}</rt-heading>
  </div>
  @for (placement of placements; track trackById($index, placement)) {
    <div class="grid-row" margin-top-small>
      <div layout-horizontal layout-align-items-center>
        <rt-avatar type="image" [imageSrc]="placement.candidate.photoThumbUrl"></rt-avatar>
        <rt-truncate class="candidate-name" margin-left-small>{{
          placement.candidate.name
        }}</rt-truncate>
      </div>

      <div>
        <rt-icon name="keyboard-backspace" margin-lr-medium></rt-icon>
      </div>

      @if (requisitionOptionsByPlacementId.get(placement.id); as options) {
        <rt-select
          [triggerTemplate]="selectRequisitionTrigger"
          [disabled]="
            autoRequisitionsAssign ||
            (!availableRequisitions.length && !getRequisitionControl(placement.id).value)
          "
          [options]="options"
          [formControl]="getRequisitionControl(placement.id)"
          [hasInputTrigger]="true"
          [hasSearch]="options.length > 5"
          [placeholder]="texts.select"
          margin-right-small-x
        ></rt-select>
      }

      @if (openingOptionsByPlacementId.get(placement.id); as options) {
        <rt-select
          [triggerTemplate]="selectTrigger"
          [disabled]="autoAssignOpeningsByPlacementId.get(placement.id) || !options.length"
          [options]="options"
          [formControl]="getOpeningControl(placement.id)"
          [hasInputTrigger]="true"
          [hasSearch]="options.length > 5"
          [placeholder]="availableOpeningsNumber ? texts.select : texts.notAssigned"
          margin-left-small-x
        ></rt-select>
      }
    </div>

    <ng-template
      #selectTrigger
      let-selectedOption="selectedOption"
      let-dropdownOpened="dropdownOpened"
      let-toggleDropdown="toggleDropdown"
      let-disabled="disabled"
      let-placeholder="placeholder"
    >
      <rt-input
        #input
        [disabled]="disabled"
        [readOnly]="true"
        [placeholder]="placeholder"
        [hasDropdownIndicator]="!selectedOption?.value && !disabled"
        [class.dropdownOpened]="dropdownOpened"
        [value]="selectedOption?.value && selectedOption?.label ? selectedOption.label : ''"
        [invalid]="false"
        [hasClearButton]="!!selectedOption?.value && !disabled"
        (reset)="
          input.setBlur();
          $event.stopPropagation();
          getOpeningControl(placement.id)?.patchValue(null)
        "
        (click)="!disabled && !dropdownOpened && toggleDropdown(true)"
        variant="rounded"
      >
      </rt-input>
    </ng-template>
    <ng-template
      #selectRequisitionTrigger
      let-selectedOption="selectedOption"
      let-dropdownOpened="dropdownOpened"
      let-toggleDropdown="toggleDropdown"
      let-disabled="disabled"
      let-placeholder="placeholder"
    >
      <rt-input
        #input
        [disabled]="disabled"
        [readOnly]="true"
        [placeholder]="placeholder"
        [hasDropdownIndicator]="!selectedOption?.value && !disabled"
        [class.dropdownOpened]="dropdownOpened"
        [value]="selectedOption?.value && selectedOption?.label ? selectedOption.label : ''"
        [invalid]="false"
        [hasClearButton]="!!selectedOption?.value && !disabled"
        (reset)="
          input.setBlur();
          $event.stopPropagation();
          getRequisitionControl(placement.id)?.patchValue(null);
          getOpeningControl(placement.id)?.patchValue(null)
        "
        (click)="!disabled && !dropdownOpened && toggleDropdown(true)"
        variant="rounded"
      >
      </rt-input>
    </ng-template>
  }
</rt-dialog-body>

<rt-dialog-footer [hasOptionalActions]="true">
  <rt-button (click)="cancel()" variant="plain">
    {{ 'app.common.cancel' | translate }}
  </rt-button>
  <rt-button [disabled]="form.invalid" (click)="save()" variant="primary">{{
    'app.requisitions.assign_hires_dialog.agree_label' | translate
  }}</rt-button>
</rt-dialog-footer>
